import * as React from "react";
import Rating from "@mui/material/Rating";
import Box from "@mui/material/Box";
import StarIcon from "@mui/icons-material/Star";

const labels: { [index: string]: string } = {
  1: "Useless",
  2: "Poor",
  3: "Ok",
  4: "Good",
  5: "Excellent",
  6: "Very Good",
  7: "Great",
  8: "Amazing",
  9: "Incredible",
  10: "Phenomenal",
};

function getLabelText(value: number) {
  return `${value} Star${value !== 1 ? "s" : ""}, ${labels[value]}`;
}

export default function HoverRating({handleRating}) {
  const [value, setValue] = React.useState<number | null>(2);
  const [hover, setHover] = React.useState(-1);

  return (
    <Box sx={{ width: 200, display: "flex", alignItems: "center" }}>
      <Rating
        name="hover-feedback"
        value={value}
        sx={{ color: "#284CB1", fontFamily: "Lexend" }}
        precision={1}
        max={10}
        getLabelText={getLabelText}
        onChange={(event, newValue) => {
          setValue(newValue);
          handleRating(newValue);
        }}
        onChangeActive={(event, newHover) => {
          setHover(newHover);
          
        }}
        emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
      />
      {value !== null && (
        <Box sx={{ ml: 2 }}>{labels[hover !== -1 ? hover : value]}</Box>
      )}
    </Box>
  );
}
